import React, { useEffect, useState } from "react";
import { auth } from "../../firebase";
import { User } from "@firebase/auth";

export const AuthContext = React.createContext<User | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    return auth.onAuthStateChanged((user) => {
      if (user) {
        user
          ?.getIdToken(true)
          .then(() => {
            setCurrentUser(user);
            setPending(false);
          })
          .catch(() => {
            setCurrentUser(null);
            setPending(false);
          });
      } else {
        setCurrentUser(null);
        setPending(false);
      }
    });
  }, []);

  if (pending) {
    return <Spinner />;
  }

  return (
    <AuthContext.Provider value={currentUser}>{children}</AuthContext.Provider>
  );
};

const Spinner = () => {
  return (
    <div className="bg-white xs:mt-16 xs:rounded shadow-xl mx-auto p-4 xs:max-w-sm">
      <div className="w-full text-blue-500 flex items-center justify-center my-12">
        <i className="fa fa-spin fa-circle-notch fa-3x" />
      </div>
    </div>
  );
};
